module.exports = __webpack_public_path__ + "static/media/transparent.2e1b7003.svg";